var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 0C26.9713 0 29 2.06638 29 4.61538V19.3846C29 21.9336 26.9713 24 24.4688 24H4.53125C2.02871 24 0 21.9336 0 19.3846V4.61538C0 2.06638 2.02871 0 4.53125 0H24.4688ZM27.1875 7.31262L14.9595 14.6418C14.7231 14.7834 14.4395 14.807 14.1874 14.7126L14.0405 14.6418L1.8125 7.31631V19.3846C1.8125 20.914 3.02973 22.1538 4.53125 22.1538H24.4688C25.9703 22.1538 27.1875 20.914 27.1875 19.3846V7.31262ZM24.4688 1.84615H4.53125C3.02973 1.84615 1.8125 3.08598 1.8125 4.61538V5.17292L14.5 12.7752L27.1875 5.17108V4.61538C27.1875 3.08598 25.9703 1.84615 24.4688 1.84615Z",
    fill: "#C47906"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.c7b93859e19c0cf31f210e19d55d14bf.svg";
export { ForwardRef as ReactComponent };